import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ProgressIndicator extends Component {
  static propTypes = {
    progressBar: PropTypes.bool,
    extraCopy: PropTypes.string,
    steps: PropTypes.number.isRequired,
    currentStep: PropTypes.number.isRequired,
  }

  static defaultProps = {
    progressBar: false,
    extraCopy: ''
  }

  renderDotsIndicator () {
    const dots = [];

    for (let i = 1; i <= this.props.steps; i++) {
      const state = this.props.currentStep === i ? ' is-active' : '';
      dots.push(<li key={`i-${i}`} className={`ProgressIndicator-dot${state}`} />);
    }
    return (
      <ol className="ProgressIndicator">
        {dots}
      </ol>
    );
  }

  renderProgressBar () {
    const progress = (this.props.currentStep * 100) /  this.props.steps;
    return (
      <div>
        <div className="u-relative u-rounded u-h-2 u-w-full u-bg-grey-light">
          <div className="u-absolute u-left-0 u-top-0 u-bottom-0 u-bg-green u-rounded" style={{width: `${Math.ceil(progress)}%`}} />
        </div>
        {this.props.extraCopy !== '' &&
        <div className="u-text-grey-darker u-text-sm u-mt-2">
          Completed by {Math.ceil(progress)}% of {this.props.extraCopy}
        </div>
        }
      </div>
    );
  }

  render() {
    return this.props.progressBar ? this.renderProgressBar() : this.renderDotsIndicator();
  }
}
